<template>
  <div>
    <PageHeader :schema="$schemas.priceList" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.priceList"
        :service="$api.priceLists"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreatePriceList',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
